import React from "react";

const BlogSeoFields = ({ values, errors, touched, handleChange, handleBlur }) => {
  const seoTitle = values.seo_title || "";
  const seoDescription = values.seo_description || "";
  const previewTitle = seoTitle.trim() || values.title || "Blog post title";
  const previewDescription = seoDescription.trim() || "Add an SEO description to preview how this article may appear in search results.";

  return (
    <section className="blog-seo-fields" aria-labelledby="blog-seo-heading">
      <div className="blog-seo-fields__header">
        <div>
          <h4 id="blog-seo-heading">Search appearance</h4>
          <p>Optional. Empty fields automatically use the blog title and content excerpt.</p>
        </div>
        <span>SEO</span>
      </div>

      <div className="row with-forms">
        <div className="col-md-12">
          <div className="blog-seo-field-label">
            <h5>SEO title</h5>
            <span className={seoTitle.length > 60 ? "is-over" : ""}>{seoTitle.length}/60</span>
          </div>
          <input
            type="text"
            name="seo_title"
            id="seo_title"
            placeholder={values.title || "Title shown in search results"}
            autoComplete="off"
            value={seoTitle}
            onChange={handleChange}
            onBlur={handleBlur}
            maxLength={70}
            className={errors.seo_title && touched.seo_title ? "form-input error" : "form-input"}
          />
          {errors.seo_title && touched.seo_title && <div className="error">{errors.seo_title}</div>}
        </div>
      </div>

      <div className="row with-forms">
        <div className="col-md-12">
          <div className="blog-seo-field-label">
            <h5>SEO description</h5>
            <span className={seoDescription.length > 160 ? "is-over" : ""}>{seoDescription.length}/160</span>
          </div>
          <textarea
            name="seo_description"
            id="seo_description"
            placeholder="A concise summary that gives searchers a reason to open this article."
            value={seoDescription}
            onChange={handleChange}
            onBlur={handleBlur}
            maxLength={180}
            rows={4}
            className={errors.seo_description && touched.seo_description ? "form-input error" : "form-input"}
          />
          {errors.seo_description && touched.seo_description && <div className="error">{errors.seo_description}</div>}
        </div>
      </div>

      <div className="blog-seo-serp-preview" aria-label="Search result preview">
        <span className="blog-seo-serp-preview__site">swanpass.com › blogs</span>
        <strong>{previewTitle}</strong>
        <p>{previewDescription}</p>
      </div>
    </section>
  );
};

export default BlogSeoFields;
